export const firstPhoneDigits = (t) => {
  const clean = (d) => (d.length >= 12 ? d.replace(/^55/, "") : d);
  const all = (t || "").replace(/\D/g, "");
  if (all.length >= 10 && all.length <= 13) return clean(all);
  const m = (t || "").match(/\(?\d{2}\)?[\s.\-]?9?\d{4,5}[\s.\-]?\d{4}/);
  return m ? clean(m[0].replace(/\D/g, "")) : "";
};
